import { faqItems, contactInfo, topicTags, cardItems } from '@/mocks/homeData';

/* ===== Section: FAQ ===== */
export function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          常见问题
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqItems.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-lg p-5 md:p-6">
              <h3 className="text-sm md:text-base text-foreground-800 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.question}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-6">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ===== Section: Contact ===== */
export function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">
          {contactInfo.title}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl mx-auto">
          {contactInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <div className="flex items-center gap-3 bg-background-50 rounded-lg px-5 py-3">
            <span className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
              <i className="ri-mail-line text-primary-500 text-lg"></i>
            </span>
            <span className="text-sm text-foreground-700 whitespace-nowrap">{contactInfo.email}</span>
          </div>
          <div className="flex items-center gap-3 bg-background-50 rounded-lg px-5 py-3">
            <span className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
              <i className="ri-wechat-line text-accent-600 text-lg"></i>
            </span>
            <span className="text-sm text-foreground-700 whitespace-nowrap">{contactInfo.wechat}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ===== Section: Topics ===== */
export function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((tag, idx) => (
            <a
              key={idx}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-200 cursor-pointer whitespace-nowrap ${
                tag.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-100 border-background-200 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {tag.hot && <i className="ri-fire-line text-accent-500 text-xs"></i>}
              <span className="text-sm">{tag.name}</span>
              <span className="text-xs opacity-60">{tag.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ===== Section: Cards ===== */
export function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          最新爆料
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardItems.slice(0, 7).map((card, idx) => (
            <div key={idx} className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer transition-all duration-200 hover:-translate-y-0.5">
              <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  title={card.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-xs bg-primary-500 text-background-50 rounded whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base text-foreground-800 mb-2 line-clamp-2 leading-snug">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {card.summary}
                </p>
                <span className="text-xs text-foreground-400">{card.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}